// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedPatients_root__3wFhB"};